// Begin route-url utils
const getParentChildUrl = (parent, child) => child ? `${parent}/${child}` : parent;

// Dashboard
export const getDashboardUrl = filter => getParentChildUrl('/dashboard', filter);
export const getUpdateAttendanceUrl = () => getDashboardUrl('update-attendance');
export const getUpdateNinjasUrl = () => getDashboardUrl('/update-ninjas');



/** WEBPACK FOOTER **
 ** ./src/route-urls.js
 **/